export default __webpack_public_path__ + "static/media/logo-rio-cor.717fe894.png";